export const hotArticles = [
  {
    id: 1,
    title: "某顶流男星深夜密会神秘女子，两人举止亲密疑似恋情曝光",
    slug: "top-star-secret-date",
    category: "明星八卦",
    categorySlug: "star-gossip",
    excerpt: "据知情人士透露，该男星与神秘女子在某高档餐厅共进晚餐后，一同返回私人住所，引发粉丝热议。",
    image: "https://readdy.ai/api/search-image?query=Celebrity%20gossip%20night%20scene%2C%20paparazzi%20style%20photograph%20of%20two%20people%20walking%20in%20dark%20alley%2C%20moody%20lighting%2C%20cinematic%20composition%2C%20warm%20street%20lamp%20glow%2C%20no%20text%2C%20editorial%20photography%20style%2C%20soft%20shadows&width=800&height=600&seq=hot-article-01&orientation=landscape",
    heat: 98500,
    isHot: true,
    isExclusive: true,
    publishedAt: "2026-06-29T10:30:00Z",
    author: "吃瓜小编",
    tags: ["恋情曝光", "顶流男星", "深夜密会"]
  },
  {
    id: 2,
    title: "某综艺节目录制现场爆发激烈冲突，导演组紧急叫停",
    slug: "variety-show-conflict",
    category: "综艺内幕",
    categorySlug: "variety-insider",
    excerpt: "据现场工作人员爆料，两位常驻嘉宾在录制过程中因游戏环节产生严重分歧，场面一度失控。",
    image: "https://readdy.ai/api/search-image?query=TV%20variety%20show%20set%20with%20dramatic%20lighting%2C%20stage%20lights%20and%20cameras%2C%20tense%20atmosphere%2C%2C%20no%20text%2C%20production%20set%20photography%2C%20dynamic%20composition&width=800&height=600&seq=hot-article-02&orientation=landscape",
    heat: 87200,
    isHot: true,
    isExclusive: false,
    publishedAt: "2026-06-29T08:15:00Z",
    author: "综艺前线",
    tags: ["综艺节目", "嘉宾冲突", "录制事故"]
  },
  {
    id: 3,
    title: "知名女星被曝与经纪人关系破裂，十年合作或将终止",
    slug: "actress-agent-split",
    category: "明星八卦",
    categorySlug: "star-gossip",
    excerpt: "多方消息源确认，该女星与经纪人近期多次发生争执，工作室内部气氛紧张。",
    image: "https://readdy.ai/api/search-image?query=Female%20celebrity%20walking%20alone%20on%20red%20carpet%2C%20paparazzi%20shot%2C%20dramatic%20evening%20lighting%2C%20fashion%20event%20background%20blur%2C%20no%20text%2C%20editorial%20style&width=800&height=600&seq=hot-article-03&orientation=landscape",
    heat: 76100,
    isHot: true,
    isExclusive: true,
    publishedAt: "2026-06-28T22:45:00Z",
    author: "圈内老鬼",
    tags: ["女星", "经纪人", "合作关系"]
  },
  {
    id: 4,
    title: "某古装剧剧组被曝片酬分配不公，配角演员集体抗议",
    slug: "drama-salary-dispute",
    category: "影视爆料",
    categorySlug: "film-tv-leaks",
    excerpt: "据剧组内部人士透露，部分配角演员片酬远低于行业标准，而主角片酬却高得离谱。",
    image: "https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20film%20set%20costumes%20and%20props%2C%20behind%20the%20scenes%20photography%2C%20traditional%20architecture%20background%2C%20warm%20lighting%2C%20no%20text%2C%20cinematic%20mood&width=800&height=600&seq=hot-article-04&orientation=landscape",
    heat: 65400,
    isHot: true,
    isExclusive: false,
    publishedAt: "2026-06-28T18:20:00Z",
    author: "影视观察员",
    tags: ["古装剧", "片酬", "演员抗议"]
  },
  {
    id: 5,
    title: "当红小生被拍到与神秘女子同游日本，疑似新恋情浮出水面",
    slug: "actor-japan-date",
    category: "明星八卦",
    categorySlug: "star-gossip",
    excerpt: "网友在日本东京偶遇该小生与一女子手牵手逛街，两人状态亲密自然。",
    image: "https://readdy.ai/api/search-image?query=Couple%20walking%20in%20Tokyo%20street%20at%20night%2C%20neon%20lights%20background%2C%20romantic%20atmosphere%2C%20paparazzi%20style%20candid%20shot%2C%20no%20text%2C%20warm%20city%20glow&width=800&height=600&seq=hot-article-05&orientation=landscape",
    heat: 58900,
    isHot: false,
    isExclusive: true,
    publishedAt: "2026-06-28T14:10:00Z",
    author: "海外吃瓜",
    tags: ["当红小生", "日本", "新恋情"]
  },
  {
    id: 6,
    title: "某选秀节目选手被曝学历造假，节目组回应称正在核实",
    slug: "talent-show-fake-degree",
    category: "综艺内幕",
    categorySlug: "variety-insider",
    excerpt: "该选手在节目中自称某知名高校毕业，但网友查询发现其并未在该校就读记录。",
    image: "https://readdy.ai/api/search-image?query=Talent%20show%20stage%20with%20spotlights%20and%20microphone%2C%20dramatic%20performance%20setting%2C%20empty%20stage%20before%20show%2C%20no%20text%2C%20theatrical%20lighting%2C%20warm%20and%20dramatic&width=800&height=600&seq=hot-article-06&orientation=landscape",
    heat: 52300,
    isHot: false,
    isExclusive: false,
    publishedAt: "2026-06-28T09:30:00Z",
    author: "选秀观察",
    tags: ["选秀节目", "学历造假", "选手争议"]
  },
  {
    id: 7,
    title: "两大顶流品牌代言争夺战白热化，双方团队暗中较劲",
    slug: "brand-endorsement-war",
    category: "商务爆料",
    categorySlug: "business-leaks",
    excerpt: "某国际奢侈品牌正在两位顶流艺人之间摇摆不定，代言合同金额或创下新纪录。",
    image: "https://readdy.ai/api/search-image?query=Luxury%20brand%20flagship%20store%20exterior%20at%20night%2C%20elegant%20display%20windows%2C%20upscale%20shopping%20district%2C%20no%20text%2C%20commercial%20photography%2C%20warm%20golden%20lighting&width=800&height=600&seq=hot-article-07&orientation=landscape",
    heat: 48700,
    isHot: false,
    isExclusive: true,
    publishedAt: "2026-06-27T20:00:00Z",
    author: "商业观察",
    tags: ["品牌代言", "顶流", "商业竞争"]
  },
  {
    id: 8,
    title: "某知名导演新片选角内幕曝光，多位一线明星争抢主角",
    slug: "director-casting-secrets",
    category: "影视爆料",
    categorySlug: "film-tv-leaks",
    excerpt: "据悉该导演的新片题材敏感，多家投资方看好，男女主角人选竞争异常激烈。",
    image: "https://readdy.ai/api/search-image?query=Film%20director%20chair%20on%20empty%20movie%20set%2C%20professional%20camera%20equipment%2C%20behind%20the%20scenes%20cinema%20production%2C%20no%20text%2C%20cinematic%20lighting%2C%20warm%20dramatic%20tone&width=800&height=600&seq=hot-article-08&orientation=landscape",
    heat: 41200,
    isHot: false,
    isExclusive: false,
    publishedAt: "2026-06-27T15:45:00Z",
    author: "电影老兵",
    tags: ["导演", "选角", "新片"]
  }
];

export const categories = [
  {
    name: "明星八卦",
    slug: "star-gossip",
    icon: "ri-star-line",
    count: 326,
    isHot: true,
    image: "https://readdy.ai/api/search-image?query=Red%20carpet%20event%20with%20celebrities%20and%20flashing%20cameras%2C%20glamorous%20atmosphere%2C%20no%20text%2C%20fashion%20event%20photography%2C%20warm%20spotlight%20glow%2C%20elegant%20composition&width=600&height=400&seq=category-star-gossip&orientation=landscape"
  },
  {
    name: "综艺内幕",
    slug: "variety-insider",
    icon: "ri-tv-line",
    count: 218,
    isHot: true,
    image: "https://readdy.ai/api/search-image?query=TV%20studio%20with%20colorful%20stage%20lights%20and%20cameras%2C%20variety%20show%20set%20design%2C%20no%20text%2C%20bright%20entertainment%20atmosphere%2C%20dynamic%20studio%20photography&width=600&height=400&seq=category-variety&orientation=landscape"
  },
  {
    name: "影视爆料",
    slug: "film-tv-leaks",
    icon: "ri-movie-line",
    count: 195,
    isHot: false,
    image: "https://readdy.ai/api/search-image?query=Film%20production%20set%20with%20professional%20equipment%2C%20movie%20camera%20and%20lighting%20rig%2C%20no%20text%2C%20cinematic%20behind%20the%20scenes%2C%20warm%20dramatic%20lighting&width=600&height=400&seq=category-film-tv&orientation=landscape"
  },
  {
    name: "商务爆料",
    slug: "business-leaks",
    icon: "ri-briefcase-line",
    count: 142,
    isHot: false,
    image: "https://readdy.ai/api/search-image?query=Luxury%20brand%20store%20interior%20elegant%20design%2C%20upscale%20shopping%20atmosphere%2C%20no%20text%2C%20commercial%20photography%2C%20warm%20golden%20ambient%20lighting&width=600&height=400&seq=category-business&orientation=landscape"
  },
  {
    name: "音乐圈",
    slug: "music-circle",
    icon: "ri-music-line",
    count: 167,
    isHot: false,
    image: "https://readdy.ai/api/search-image?query=Concert%20stage%20with%20colorful%20laser%20lights%20and%20musical%20instruments%2C%20live%20music%20atmosphere%2C%20no%20text%2C%20dynamic%20performance%20photography&width=600&height=400&seq=category-music&orientation=landscape"
  },
  {
    name: "网红圈",
    slug: "influencer-circle",
    icon: "ri-live-line",
    count: 283,
    isHot: true,
    image: "https://readdy.ai/api/search-image?query=Social%20media%20influencer%20filming%20with%20ring%20light%20and%20smartphone%2C%20modern%20content%20creation%20setup%2C%20no%20text%2C%20warm%20studio%20lighting%2C%20trendy%20aesthetic&width=600&height=400&seq=category-influencer&orientation=landscape"
  },
  {
    name: "时尚圈",
    slug: "fashion-circle",
    icon: "ri-shirt-line",
    count: 156,
    isHot: false,
    image: "https://readdy.ai/api/search-image?query=Fashion%20runway%20show%20with%20models%20and%20spotlights%2C%20high%20fashion%20event%20atmosphere%2C%20no%20text%2C%20elegant%20catwalk%20photography%2C%20dramatic%20lighting&width=600&height=400&seq=category-fashion&orientation=landscape"
  },
  {
    name: "体育圈",
    slug: "sports-circle",
    icon: "ri-basketball-line",
    count: 134,
    isHot: false,
    image: "https://readdy.ai/api/search-image?query=Sports%20stadium%20with%20bright%20floodlights%2C%20athletic%20atmosphere%2C%20empty%20field%20before%20game%2C%20no%20text%2C%20dynamic%20sports%20photography%2C%20dramatic%20sky&width=600&height=400&seq=category-sports&orientation=landscape"
  }
];

export const reviews = [
  {
    id: 1,
    username: "吃瓜第一名",
    handle: "@chigua_no1",
    avatar: "https://readdy.ai/api/search-image?query=Young%20Chinese%20person%20portrait%2C%20minimalist%20studio%20headshot%2C%20warm%20neutral%20background%2C%20natural%20lighting%2C%20no%20text&width=100&height=100&seq=avatar-review-01&orientation=squarish",
    content: "51吃瓜网真的太强了！每次有大瓜都是这里最先看到，更新速度简直离谱。身边的朋友现在都在这蹲瓜，已经安利给全公司了！",
    rating: 5
  },
  {
    id: 2,
    username: "娱乐圈老司机",
    handle: "@showbiz_veteran",
    avatar: "https://readdy.ai/api/search-image?query=Mature%20Chinese%20man%20portrait%2C%20professional%20headshot%2C%20warm%20studio%20background%2C%20confident%20expression%2C%20no%20text&width=100&height=100&seq=avatar-review-02&orientation=squarish",
    content: "做了十年娱记，51吃瓜网的料比很多同行都快，而且准确率相当高。看得出来背后有非常靠谱的信息源，每次看都觉得值。",
    rating: 5
  },
  {
    id: 3,
    username: "深夜吃瓜人",
    handle: "@late_night_eater",
    avatar: "https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%2C%20casual%20studio%20headshot%2C%20warm%20lighting%2C%20friendly%20smile%2C%20no%20text&width=100&height=100&seq=avatar-review-03&orientation=squarish",
    content: "每天晚上睡前必刷一遍51吃瓜网，简直是助眠神器（虽然经常越看越精神）。分类很清晰，想看的瓜一找一个准。",
    rating: 4
  },
  {
    id: 4,
    username: "真相挖掘机",
    handle: "@truth_digger",
    avatar: "https://readdy.ai/api/search-image?query=Chinese%20man%20portrait%20with%20glasses%2C%20intellectual%20look%2C%20studio%20headshot%2C%20warm%20background%2C%20no%20text&width=100&height=100&seq=avatar-review-04&orientation=squarish",
    content: "对比过好几个吃瓜平台，51吃瓜网的爆料深度和独家性确实领先。不是那种标题党，每条瓜下面都有干货，这点很难得。",
    rating: 5
  },
  {
    id: 5,
    username: "八卦小能手",
    handle: "@gossip_pro",
    avatar: "https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%2C%20trendy%20style%2C%20studio%20headshot%2C%20warm%20lighting%2C%20energetic%20expression%2C%20no%20text&width=100&height=100&seq=avatar-review-05&orientation=squarish",
    content: "从微博转战过来的，发现51吃瓜网的内容质量高太多了。没有水军刷屏，评论区也都是真瓜友在讨论，氛围超好。",
    rating: 4
  },
  {
    id: 6,
    username: "茶余饭后",
    handle: "@teatime_gossip",
    avatar: "https://readdy.ai/api/search-image?query=Middle%20aged%20Chinese%20woman%20portrait%2C%20elegant%20studio%20headshot%2C%20warm%20natural%20lighting%2C%20gentle%20smile%2C%20no%20text&width=100&height=100&seq=avatar-review-06&orientation=squarish",
    content: "办公室午休时间全靠51吃瓜网的瓜来下饭了！每天午饭时间大家都在分享今天的新瓜，已经成了我们部门的文化传统。",
    rating: 5
  }
];

export const articleDetail: Record<number, {
  id: number;
  title: string;
  slug: string;
  category: string;
  categorySlug: string;
  content: string;
  image: string;
  heat: number;
  isHot: boolean;
  isExclusive: boolean;
  publishedAt: string;
  author: string;
  tags: string[];
  comments: Array<{
    id: number;
    username: string;
    handle: string;
    avatar: string;
    content: string;
    time: string;
    likes: number;
  }>;
}> = {
  1: {
    ...hotArticles[0],
    content: `<p>【51吃瓜网独家报道】近日，有知情人士向本网独家爆料，某当红顶流男星与一位神秘女子深夜约会的画面被拍下，引发全网热议。</p>
    <p>据悉，该男星当天结束工作后，并未直接返回住所，而是驱车前往位于市中心的一家高档日料餐厅。据餐厅工作人员透露，他预订了一个私密包间，随后一位身穿黑色长裙的神秘女子进入包间，两人在包间内共处约两小时。</p>
    <p>用餐结束后，两人并未分开，而是同乘一辆保姆车前往该男星位于城东的私人住所。据附近居民反映，该女子的车辆次日清晨才从小区驶出。</p>
    <p>目前该男星方面尚未对此事做出回应，其工作室电话一直处于无人接听状态。圈内人士分析，如果此事属实，可能会对该男星正在洽谈的几个重要代言项目产生影响。</p>
    <p>本网将持续关注此事进展，为瓜友们带来第一手资讯。</p>`
  },
  2: {
    ...hotArticles[1],
    content: `<p>【51吃瓜网独家报道】据现场工作人员爆料，某热门综艺节目在最新一期录制过程中突发意外状况，两位常驻嘉宾因游戏环节规则争议爆发激烈冲突。</p>
    <p>据悉，当时正在进行一个团队竞技游戏环节，其中一位嘉宾认为对方队伍存在违规行为，当场提出质疑。另一位嘉宾随即反驳，双方言辞逐渐激烈，现场气氛一度非常紧张。</p>
    <p>导演组见状立即叫停录制，将两位嘉宾分别请到不同的休息室进行调解。据目击者称，其中一位嘉宾情绪激动，甚至摔了手中的道具。整个录制被迫中断约两个小时。</p>
    <p>节目组随后发布简短声明称："录制过程中出现的意见分歧已得到妥善解决，节目将继续正常录制和播出。"但对于冲突的具体细节，节目组未做进一步说明。</p>
    <p>值得一提的是，这已经不是该节目第一次出现嘉宾之间的摩擦。此前曾有观众注意到两位嘉宾在社交平台上的一些微妙互动，现在看来似乎早有端倪。</p>`
  },
  3: {
    ...hotArticles[2],
    content: `<p>【51吃瓜网独家报道】据多方消息源确认，知名女星李某与其合作长达十年的经纪人王某之间的关系出现严重裂痕，双方近期多次发生激烈争执。</p>
    <p>据工作室内部人士透露，矛盾的导火索是近期一部大制作电影的选角问题。经纪人王某力主李某接下该片女主角，认为这是一个提升咖位的好机会。但李某本人对剧本质量存疑，认为角色与自身形象不符。</p>
    <p>此外，在商业代言和综艺节目选择上，双方也存在严重分歧。经纪人倾向于接更多的商业活动和综艺以维持曝光度，而李某则希望减少工作量，专注于演技提升。</p>
    <p>如果双方最终分道扬镳，这将是娱乐圈近年来最受关注的一对艺人与经纪人"分手"案例。十年的合作关系一旦破裂，对双方的事业都可能产生深远影响。</p>`
  }
};

// Fill in missing article details from hotArticles
for (const article of hotArticles) {
  if (!articleDetail[article.id]) {
    articleDetail[article.id] = {
      ...article,
      content: `<p>【51吃瓜网独家报道】${article.excerpt}</p><p>更多详情正在持续追踪中，敬请关注51吃瓜网后续报道。我们将为瓜友们带来最新、最全的吃瓜资讯。</p>`,
      comments: []
    };
  }
}

// Add comments to all articles
for (const id in articleDetail) {
  articleDetail[Number(id)].comments = [
    {
      id: 1,
      username: "吃瓜群众甲",
      handle: "@melon_fan_a",
      avatar: "https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%2C%20casual%20headshot%2C%20warm%20background%2C%20friendly%20expression%2C%20no%20text&width=100&height=100&seq=comment-avatar-01&orientation=squarish",
      content: "卧槽这个瓜保熟吗？坐等后续！！",
      time: "2小时前",
      likes: 328
    },
    {
      id: 2,
      username: "今天也在吃瓜",
      handle: "@eating_melon",
      avatar: "https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%2C%20stylish%20headshot%2C%20warm%20lighting%2C%20playful%20expression%2C%20no%20text&width=100&height=100&seq=comment-avatar-02&orientation=squarish",
      content: "终于有人爆这个了！我在某书看到过类似的帖子但是被删了",
      time: "3小时前",
      likes: 256
    },
    {
      id: 3,
      username: "真相只有一个",
      handle: "@one_truth",
      avatar: "https://readdy.ai/api/search-image?query=Mature%20Chinese%20person%20portrait%2C%20serious%20headshot%2C%20warm%20background%2C%20thoughtful%20expression%2C%20no%20text&width=100&height=100&seq=comment-avatar-03&orientation=squarish",
      content: "圈内人都知道的事，只不过51吃瓜网是第一个敢公开说的。respect！",
      time: "4小时前",
      likes: 189
    },
    {
      id: 4,
      username: "吃瓜不嫌事大",
      handle: "@drama_lover",
      avatar: "https://readdy.ai/api/search-image?query=Young%20Chinese%20person%20portrait%2C%20energetic%20headshot%2C%20warm%20studio%20lighting%2C%20excited%20expression%2C%20no%20text&width=100&height=100&seq=comment-avatar-04&orientation=squarish",
      content: "前排留名！这个瓜我要蹲到底，求持续更新！",
      time: "5小时前",
      likes: 145
    },
    {
      id: 5,
      username: "理性吃瓜人",
      handle: "@rational_viewer",
      avatar: "https://readdy.ai/api/search-image?query=Chinese%20person%20with%20glasses%20portrait%2C%20intellectual%20headshot%2C%20warm%20background%2C%20calm%20expression%2C%20no%20text&width=100&height=100&seq=comment-avatar-05&orientation=squarish",
      content: "理性分析一波，这事可能没表面看起来那么简单，等更多证据出来再下结论",
      time: "6小时前",
      likes: 97
    }
  ];
}